import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Form, Button, Container, Card, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';

const M11_Ejercicio10 = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [step, setStep] = useState(1);
    
    const [respuestas, setRespuestas] = useState({
        palabras_clave: '',
        texto_reconstruido: '',
        comparacion: {
            faltantes: '',
            aciertos: '',
            errores: ''
        },
        texto_mejorado: ''
    });

    const textoBase = `COSTO DE CALIDAD

El costo de calidad es una herramienta administrativa que permite a una empresa determinar cuánto le cuesta producir con calidad o sin ella. Muchas veces, los errores, fallas o defectos en los productos generan gastos adicionales que podrían evitarse si se implementaran procesos adecuados desde el inicio.

Existen diferentes tipos de costos de calidad: los costos de prevención, que se enfocan en evitar errores antes de que ocurran; los costos de evaluación, que se relacionan con la inspección y revisión de productos; y los costos de fallas, que incluyen tanto fallas internas como externas.

Las fallas internas se detectan antes de que el producto llegue al cliente, mientras que las externas se identifican después de la entrega, lo que puede generar mayores pérdidas, reclamos o daños a la reputación de la empresa.

Implementar un sistema de calidad eficiente permite reducir costos a largo plazo, mejorar la satisfacción del cliente y aumentar la competitividad en el mercado.`;

    const handleChange = (campo, valor) => {
        setRespuestas(prev => ({ ...prev, [campo]: valor }));
    };

    const handleComparacion = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            comparacion: {
                ...prev.comparacion,
                [campo]: valor
            }
        }));
    };

    const nextStep = () => {
        if (!modoConsulta && (step === 2 && !respuestas.palabras_clave.trim())) {
            Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Ingresa al menos una palabra clave.' });
            return;
        }
        if (!modoConsulta && (step === 3 && !respuestas.texto_reconstruido.trim())) {
            Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Debes escribir la reconstrucción del texto.' });
            return;
        }
        if (!modoConsulta && (step === 4)) {
            const { faltantes, aciertos, errores } = respuestas.comparacion;
            if (!faltantes.trim() || !aciertos.trim() || !errores.trim()) {
                Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Completa tu análisis de comparación.' });
                return;
            }
        }
        setStep(prev => prev + 1);
    };
    const prevStep = () => setStep(prev => prev - 1);

    const calcularPuntaje = () => {
        let puntaje = 0;
        if (respuestas.palabras_clave.split(',').length >= 3) puntaje += 5;
        if (respuestas.texto_reconstruido.length > 50) puntaje += 5;
        if (respuestas.comparacion.aciertos.length > 10) puntaje += 5;
        if (respuestas.texto_mejorado.length > 50) puntaje += 5;
        return puntaje;
    };

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        if (!respuestas.texto_mejorado.trim()) {
            Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Por favor, escribe el texto mejorado antes de enviar.' });
            return;
        }

        const puntajeFinal = calcularPuntaje();

        try {
            await addDoc(collection(db, "evaluaciones"), {
                userId: currentUser.uid,
                nombre: "Ejercicio 10 - Memoria y Retención",
                nivel: "Avanzado",
                modulo: "11",
                createdAt: new Date(),
                tipo: "Memoria",
                respuestas: respuestas,
                puntaje: puntajeFinal,
                puntajeMaximo: 20
            });
            Swal.fire({
                title: '¡Evaluación Enviada!',
                text: `Resultados enviados con éxito. Puntaje estimado: ${puntajeFinal}/20.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Excelente'
            }).then((result) => {
                if (result.isConfirmed) {
                    cerrarModal();
                }
            });
        } catch (error) {
            console.error("Error al enviar las respuestas: ", error);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Error al enviar las respuestas.' });
        }
    };

    return (
        <Container>
            <h3 className="text-center mb-4">Ejercicio 10 - Memoria y Retención</h3>
            
            {step === 1 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-primary">
                        <Card.Body>
                            <Card.Title>Paso 1: Lectura Única</Card.Title>
                            <Card.Text>
                                <strong>Reglas:</strong> Lee el siguiente texto UNA SOLA VEZ. Concéntrate en las ideas principales. No podrás volver a leerlo en los siguientes pasos.
                            </Card.Text>
                            <div className="p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
                                {textoBase}
                            </div>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="primary" size="lg" onClick={nextStep}>Ya lo leí, ocultar texto y continuar</Button>
                    </div>
                </div>
            )}

            {step === 2 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-warning">
                        <Card.Body>
                            <Card.Title>Paso 2: Extracción de palabras clave</Card.Title>
                            <Card.Text>Sin mirar el texto, escribe todas las palabras clave que recuerdes.</Card.Text>
                        </Card.Body>
                    </Card>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Palabras Clave (separadas por comas):</Form.Label>
                            <div className="text-muted small mb-1">Ej: calidad, costos, prevención...</div>
                            <Form.Control 
                                as="textarea" 
                                rows={3} 
                                value={respuestas.palabras_clave} 
                                onChange={e => handleChange('palabras_clave', e.target.value)} 
                            />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente Paso</Button>
                    </div>
                </div>
            )}

            {step === 3 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-info">
                        <Card.Body>
                            <Card.Title>Paso 3: Reconstrucción</Card.Title>
                            <Card.Text>
                                Redacta el contenido del texto usando <strong>solo</strong> las palabras clave que anotaste como guía.
                            </Card.Text>
                            <div className="p-2 mb-3 bg-light border rounded">
                                <small className="text-muted fw-bold">Tus palabras clave:</small><br/>
                                <em>{respuestas.palabras_clave}</em>
                            </div>
                        </Card.Body>
                    </Card>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Texto reconstruido desde tu memoria:</Form.Label>
                            <div className="text-muted small mb-1">Escribe aquí tu versión del texto...</div>
                            <Form.Control 
                                as="textarea" 
                                rows={6} 
                                value={respuestas.texto_reconstruido} 
                                onChange={e => handleChange('texto_reconstruido', e.target.value)} 
                            />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente Paso</Button>
                    </div>
                </div>
            )}

            {step === 4 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-secondary">
                        <Card.Body>
                            <Card.Title>Paso 4: Comparación</Card.Title>
                            <Card.Text>Compara tu versión con el texto original y analiza las diferencias.</Card.Text>
                        </Card.Body>
                    </Card>
                    
                    <Row className="mb-4">
                        <Col md={6}>
                            <div className="p-3 bg-light border rounded h-100">
                                <h6>Texto Original:</h6>
                                <small style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>{textoBase}</small>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="p-3 bg-white border rounded border-primary h-100">
                                <h6 className="text-primary">Tu Reconstrucción:</h6>
                                <small style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>{respuestas.texto_reconstruido}</small>
                            </div>
                        </Col>
                    </Row>

                    <Form>
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>¿Qué faltó?</Form.Label>
                                    <Form.Control as="textarea" rows={2} value={respuestas.comparacion.faltantes} onChange={e => handleComparacion('faltantes', e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>¿Qué se recordó bien?</Form.Label>
                                    <Form.Control as="textarea" rows={2} value={respuestas.comparacion.aciertos} onChange={e => handleComparacion('aciertos', e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>¿Qué se interpretó mal?</Form.Label>
                                    <Form.Control as="textarea" rows={2} value={respuestas.comparacion.errores} onChange={e => handleComparacion('errores', e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente Paso</Button>
                    </div>
                </div>
            )}

            {step === 5 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-success">
                        <Card.Body>
                            <Card.Title>Paso 5: Mejora Final</Card.Title>
                            <Card.Text>Basado en tu análisis, reescribe el texto mejorando la precisión y los detalles que omitiste.</Card.Text>
                        </Card.Body>
                    </Card>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Texto Mejorado:</Form.Label>
                            <div className="text-muted small mb-1">Escribe tu versión final y mejorada del texto...</div>
                            <Form.Control 
                                as="textarea" 
                                rows={6} 
                                value={respuestas.texto_mejorado} 
                                onChange={e => handleChange('texto_mejorado', e.target.value)} 
                            />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="success" size="lg" onClick={enviarResultados}>Finalizar y Enviar</Button>
                    </div>
                </div>
            )}
        </Container>
    );
};

export default M11_Ejercicio10;
